import React, { useState } from 'react'
import styles from '../../../Style'
import Icons from '../../../../Constants/Icons'
import CustomSlider from './CustomSlider'
import { apiCallTransferEvent } from '../../../../Core/Apicall'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'

const Section = ({ title, children }) => (
  <div style={styles.menu_ic}>
    <div className='astrologerText'>{title}</div>
    {children}
  </div>
)

const HostDetails = ({ eventDetails }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [userId, setUserId] = useState('')
  const [reason, setReason] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!userId.trim()) {
      toast.info('Please enter a User ID', {
        autoClose: 1200
      })
      return
    }

    if (!reason.trim()) {
      toast.info('Please enter a Reason', {
        autoClose: 1200
      })
      return
    }
    setIsSubmitting(true)
    try {
      const res = await apiCallTransferEvent({
        eventId: eventDetails?.eventId,
        newUserId: userId,
        reason: reason
      })
      toast.success("Event transferred successfully", {
        autoClose: 1200
      })
      navigate(-1)
      setUserId('')
      setReason('')
      setIsSubmitting(false)
    } catch (error) {
      toast.error(error, {
        autoClose: 1200
      })
      setIsSubmitting(false)
    }
  }

  const renderTable = rows => (
    <table className='table'>
      <tbody>
        {rows.map(([label, value], index) => (
          <tr key={index}>
            <th>{label}</th>
            <td>{value || 'N/A'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )


  const renderProfile = (imgSrc, name) => (
    <div
      style={{
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
        marginBottom: '1rem'
      }}
    >
      <div
        style={{
          borderRadius: '50%',
          overflow: 'hidden',
          width: '70px',
          height: '70px'
        }}
      >
        <img
          style={{
            width: '70px',
            height: '70px',
            borderRadius: '70px',
            objectFit: 'cover'
          }}
          src={imgSrc || Icons.Ic_HandShot}
          alt={name}
        />
      </div>
      <div>{name || 'N/A'}</div>
    </div>
  )

  return (
    <div className='achievements'>
      <Section title='Host Details'>
        <div style={styles.HostDetails}>
          <Section title='Event Details'>
            {renderProfile(
              eventDetails?.eventDetail?.eventImages,
              eventDetails?.eventDetail?.eventName
            )}
            <CustomSlider
              slides={
                eventDetails?.eventDetail?.eventPosterImages === undefined
                  ? []
                  : eventDetails?.eventDetail?.eventPosterImages
              }
            />
            {renderTable([
              ['Start Date', eventDetails?.eventDetail?.eventStartDate],
              ['Start Time', eventDetails?.eventDetail?.eventStartTime],
              ['Type Name', eventDetails?.eventDetail?.eventTypeName],
              ['Visibility', eventDetails?.eventDetail?.eventVisibility],
              ['Requirements', eventDetails?.eventDetail?.requirements],
              ['Description', eventDetails?.eventDetail?.eventDescription]
            ])}
          </Section>
          <Section title='Event Creator'>
            {renderProfile(
              eventDetails?.eventCreator?.eventCreatorProfile,
              eventDetails?.eventCreator?.eventCreatorName
            )}
            {renderTable([
              [
                'Creator Username',
                eventDetails?.eventCreator?.eventCreatorUserName
              ],
              [
                'Creator Mobile',
                eventDetails?.eventCreator?.eventCreatorMobile
              ],
              ['Creator Email', eventDetails?.eventCreator?.eventCreatorEmail],
              ['Creator City', eventDetails?.eventCreator?.eventCreatorCity]
            ])}

            {eventDetails?.transferHistoryData && (
              <div style={{
                paddingLeft: '16px',
                paddingRight: '16px',
                marginBottom: '10px',
                padding: '10px 12px',
                backgroundColor: '#e8f5e9',
                borderRadius: '6px',
                borderLeft: '4px solid #4caf50',
                fontSize: '13px',
                color: '#2e7d32'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <span style={{ fontWeight: '600' }}>Updating:</span>
                  <span style={{ fontWeight: '500' }}>{eventDetails?.transferHistoryData?.oldUserId?.name} → {eventDetails?.transferHistoryData?.newUserId?.name}</span>
                </div>
                {eventDetails?.transferHistoryData?.reason && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '12px',
                    color: '#1b5e20',
                    marginTop: '2px'
                  }}>
                    <span style={{ fontWeight: '500' }}>Reason:</span>
                    <span>{eventDetails?.transferHistoryData?.reason}</span>
                  </div>
                )}
              </div>
            )}

            <div style={{
              marginTop: '16px',
              border: '1px solid #e8e8e8',
              borderRadius: '8px',
              backgroundColor: '#fafafa',
              width: '100%',
              paddingTop: '16px',
              paddingBottom: '16px'
            }}>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1a1a2e',
                marginBottom: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                paddingLeft: '16px',
              }}>
                Update Event Creator
              </div>

              {/* User ID Input */}
              <div style={{
                paddingLeft: '16px',
                paddingRight: '16px',
                marginBottom: '10px'
              }}>
                <input
                  type="text"
                  placeholder="Enter User ID"
                  value={userId}
                  onChange={(e) => {
                    setUserId(e.target.value)
                  }}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    fontSize: '14px',
                    color: '#1a1a2e',
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {/* Reason Input */}
              <div style={{
                paddingLeft: '16px',
                paddingRight: '16px',
                marginBottom: '10px'
              }}>
                <input
                  placeholder="Enter Reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    fontSize: '14px',
                    color: '#1a1a2e',
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {/* Submit Button */}
              <div style={{
                paddingLeft: '16px',
                paddingRight: '16px'
              }}>
                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: isSubmitting ? '#b2b2b2' : '#6c5ce7',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}
                  onMouseEnter={(e) => {
                    if (!isSubmitting) {
                      e.target.style.backgroundColor = '#5a4bd1'
                      e.target.style.transform = 'translateY(-1px)'
                      e.target.style.boxShadow = '0 4px 12px rgba(108, 92, 231, 0.3)'
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSubmitting) {
                      e.target.style.backgroundColor = '#6c5ce7'
                      e.target.style.transform = 'translateY(0)'
                      e.target.style.boxShadow = 'none'
                    }
                  }}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </Section>
          <Section title='Venue Detail'>
            {renderTable([
              ['Venue Name', eventDetails?.venueDetail?.venueName],
              ['Venue Address', eventDetails?.venueDetail?.venueAddress]
            ])}

            <div className='astrologerText'>Event Mode</div>
            {renderTable([
              ['Category Name', eventDetails?.eventMode?.categoryName],
              ['Ticket Art Name', eventDetails?.eventMode?.ticketArtName],
              ['Extra Bonus Spots', eventDetails?.eventMode?.extraBonusSpots],
              ['No Of Spots', eventDetails?.eventMode?.noOfSpots]
            ])}
          </Section>

          <Section title='All Event'>
            {renderTable([
              ['Except First', eventDetails?.exceptFirst],
              ['Except Second', eventDetails?.exceptSecond],
              ['Except Third', eventDetails?.exceptThird],
              ['Latitude', eventDetails?.latitude],
              ['Longitude', eventDetails?.longitude]
            ])}
          </Section>
          <Section title='Event Pricing'>
            {renderTable([
              ['VIP Price', eventDetails?.eventPricing?.VIPPrice],
              ['Economy Price', eventDetails?.eventPricing?.economyPrice],
              ['Event Entry', eventDetails?.eventPricing?.eventEntry],
              [
                'Latest Date For Purchase',
                eventDetails?.eventPricing?.latestDateForPurchase
              ],
              ['Ticket Page Link', eventDetails?.eventPricing?.ticketPageLink]
            ])}
          </Section>
          <Section title='Schedule Event'>
            {renderTable([
              ['Repeat Type', eventDetails?.scheduleEvent?.repeatType],
              ['Start Date', eventDetails?.scheduleEvent?.startDate],
              ['Next Event', eventDetails?.scheduleEvent?.nextEvent]
            ])}
          </Section>
        </div>
      </Section>
    </div>
  )
}

export default HostDetails
